var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hotel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Proto",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Page-v3",
    transform: "translate(-872.000000, -938.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(435.000000, 870.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(369.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotel",
    transform: "translate(68.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,12 C23.1,12 24,12.9 24,14 L24,18 C24,19.1 23.1,20 22,20 L18,20 C16.9,20 16,19.1 16,18 L16,14 C16,12.9 16.9,12 18,12 L22,12 Z M28,14 C28,12.9 28.9,12 30,12 L34,12 C35.1,12 36,12.9 36,14 L36,18 C36,19.1 35.1,20 34,20 L30,20 C28.9,20 28,19.1 28,18 L28,14 Z M46,12 C47.1,12 48,12.9 48,14 L48,18 C48,19.1 47.1,20 46,20 L42,20 C40.9,20 40,19.1 40,18 L40,14 C40,12.9 40.9,12 42,12 L46,12 Z M16,26 C16,24.9 16.9,24 18,24 L22,24 C23.1,24 24,24.9 24,26 L24,30 C24,31.1 23.1,32 22,32 L18,32 C16.9,32 16,31.1 16,30 L16,26 Z M34,24 C35.1,24 36,24.9 36,26 L36,30 C36,31.1 35.1,32 34,32 L30,32 C28.9,32 28,31.1 28,30 L28,26 C28,24.9 28.9,24 30,24 L34,24 Z M40,26 C40,24.9 40.9,24 42,24 L46,24 C47.1,24 48,24.9 48,26 L48,30 C48,31.1 47.1,32 46,32 L42,32 C40.9,32 40,31.1 40,30 L40,26 Z M61,0 C62.6625,0 64,1.34375 64,3 C64,4.65625 62.6625,6 61,6 L60,6 L60,58 L61,58 C62.6625,58 64,59.3375 64,61 C64,62.6625 62.6625,64 61,64 L3,64 C1.34375,64 0,62.6625 0,61 C0,59.3375 1.34375,58 3,58 L4,58 L4,6 L3,6 C1.34375,6 0,4.65625 0,3 C0,1.34375 1.34375,0 3,0 L61,0 Z M10,6 L10,58 L26,58 L26,48 L22,48 C20.9,48 19.9875,47.1 20.1625,46.0125 C21.1125,40.325 26.05,36 32,36 C37.95,36 42.8875,40.325 43.8375,46.0125 C44.0125,47.1 43.1,48 42,48 L38,48 L38,58 L54,58 L54,6 L10,6 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.3e786c9fd4f7d63f3d43d900dbbbbfda.svg";
export { ForwardRef as ReactComponent };